import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  locationNameFromModel,
  validateLocationNameCondition,
  type LocationNameState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const LOCATION_NAME = (
  Details: React.ComponentType<ConditionTypeDetailsProps<LocationNameState>>,
): ConditionType<LocationNameState, Condition.LocationName> => ({
  name: "Origin location name",
  description(state) {
    if (state.names.length === 0) return "No locations selected";
    if (state.names.length === 1)
      return `Origin location is "${state.names[0]}"`;
    return `Origin location is one of: ${state.names.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<LocationNameState>) {
    return React.createElement(Details, props);
  },
  empty: { names: [] },
  fromModel(model) {
    return locationNameFromModel(model);
  },
  toModel(state) {
    return { type: Condition.LOCATION_NAME, names: state.names };
  },
  valid(state) {
    return validateLocationNameCondition(state).valid;
  },
});

export { type LocationNameState } from "@redotech/redo-model/return-flow/condition-validate";
